<template>
    <div class="max-w-md w-full">
        <div>

            <img class="mx-auto h-32 w-auto" src="/images/logo.png" alt="California Electrical Training" />

            <p class="my-5 text-center text-xl leading-5 text-gray-600">
                {{ __('Enter your Student ID and the Quiz Password.') }}
            </p>
        </div>
        <form class="mt-8" action="#" method="POST" @submit.prevent="signIn">
<!--            <div>-->
<!--                <select :aria-label="__('Language')"-->
<!--                        v-model="form.lang"-->
<!--                        name="lang"-->
<!--                        id="lang"-->
<!--                        @change="changeLang()"-->
<!--                        class="mb-2 rounded-md shadow-sm appearance-none relative block w-full px-3 py-4 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:shadow-outline-orange focus:border-orange-300 focus:z-10 sm:text-sm sm:leading-5">-->
<!--                    <option value="en">English / Ingles</option>-->
<!--                    <option value="es">Spanish / Español</option>-->
<!--                </select>-->
<!--            </div>-->

            <div>
                <input :aria-label="__('Student Number')"
                       v-model="form.user_id"
                       name="user_id"
                       type="user_id"
                       class="mb-2 rounded-md shadow-sm appearance-none relative block w-full px-3 py-4 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:shadow-outline-orange focus:border-orange-300 focus:z-10 sm:text-sm sm:leading-5"
                       :placeholder="__('Student Number')" />
            </div>

            <div>
                <input :aria-label="__('Quiz Password')"
                       v-model="form.password"
                       name="quiz_password"
                       type="quiz_password"
                       required
                       class="rounded-md shadow-sm appearance-none rounded-none relative block w-full px-3 py-4 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:shadow-outline-orange focus:border-orange-300 focus:z-10 sm:text-sm sm:leading-5"
                       :placeholder="__('Quiz Password')" />
            </div>

            <div class="mt-6">
                <button type="submit"
                        class="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-orange-400 hover:bg-orange-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out">
                    {{ __('Sign In') }}
                </button>
            </div>
        </form>
    </div>
</template>
<script>
    export default {

        data() {
            return {
                form: new Form({
                    lang: App.config.locale,
                    user_id: '',
                    password: '',
                }).dontClear()
            }
        },

        created() {
            if (Storage.get('nlcaa-quiz-app')) {
                this.form = new Form(JSON.parse(Storage.get('nlcaa-quiz-app'))).dontClear()
                this.signIn();
            }
            this.readCredentialsFromUrl();
        },

        methods: {

            readCredentialsFromUrl() {
                const urlParams = new URLSearchParams(window.location.search);
                if (urlParams.has('user_id')) {
                    this.form.user_id = urlParams.get('user_id')
                }
                if (urlParams.has('password')) {
                    this.form.password = urlParams.get('password')
                }
            },

            signIn() {
                this.form.post(`/api/quiz`).then(response => {
                    this.$emit('success', response)
                    Storage.put('nlcaa-quiz-app', JSON.stringify({
                        lang: this.form.lang,
                        user_id: this.form.user_id,
                        password: this.form.password,
                    }))
                }).catch(errors => {
                    Storage.forget('nlcaa-quiz-app');
                    Toast.error(errors.first())
                })
            },

            changeLang(){
                App.request().post(`/lang`, {
                    locale: this.form.lang
                }).then(response => {
                    this.refreshPage();
                })
            }
        }
    }
</script>
